/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.config.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/

import lang from 'quasar/lang/it'

import iconSet from 'quasar/icon-set/mdi-v6'



import {Dialog,Loading,LoadingBar,Notify} from 'quasar'



export default { config: {"loadingBar":{"color":"primary","size":"4px","position":"top","skipHijack":true}},lang,iconSet,plugins: {Dialog,Loading,LoadingBar,Notify} }

